import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyTemplatesAndBlueprintsPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TemplatesAndBlueprintsContainer" */ '../src/TemplatesAndBlueprints/TemplatesAndBlueprintsPage.tsx'
			)
		).TemplatesAndBlueprintsPage,
});
